import { Code, NumberInput, Paper, Stack, Text, TextInput } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { IconWebhook } from '@tabler/icons-react'
import { FormattedMessage, useIntl } from 'react-intl'
import { buildHttpPushUrl } from '../vlmPipelineConfig'
import { PipelineFormValues } from './VlmPipelineForm'

type HttpPushSourceSettingsProps = {
  form: UseFormReturnType<PipelineFormValues>
}

export const HttpPushSourceSettings = ({
  form
}: HttpPushSourceSettingsProps) => {
  const intl = useIntl()
  const endpointPath = form.values.source.endpointPath || '<endpoint_path>'
  const port = form.values.source.port || '<port>'

  return (
    <Stack gap="md">
      <TextInput
        label={intl.formatMessage({
          id: 'vlm.pipelines.create.httpPush.label'
        })}
        description={intl.formatMessage({
          id: 'vlm.pipelines.create.httpPush.description'
        })}
        placeholder={intl.formatMessage({
          id: 'vlm.pipelines.create.httpPush.placeholder'
        })}
        leftSection={<IconWebhook size={16} />}
        {...form.getInputProps('source.endpointPath')}
      />

      <NumberInput
        label={intl.formatMessage({
          id: 'vlm.pipelines.create.httpPush.port.label'
        })}
        description={intl.formatMessage({
          id: 'vlm.pipelines.create.httpPush.port.description'
        })}
        {...form.getInputProps('source.port')}
      />

      <Paper p="md" radius="sm">
        <Stack gap="xs">
          <Text size="xs" c="dimmed">
            <FormattedMessage id="vlm.pipelines.create.httpPush.listenerInfo" />
          </Text>
          <Text size="xs" c="dimmed" mt={4}>
            <FormattedMessage id="vlm.pipelines.create.httpPush.curlExample" />
          </Text>
          <Code fz={11} bg="dark.7" c="gray.1" block>
            {`curl -X POST ${buildHttpPushUrl(port, endpointPath)} \\\n  -F "file=@/path/to/video.mp4"`}
          </Code>
        </Stack>
      </Paper>
    </Stack>
  )
}
